var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 19.956q3.24-2.898 4.808-5.265t1.567-4.205q0-2.82-1.846-4.618Q14.684 4.07 12 4.07q-2.683 0-4.529 1.798t-1.846 4.618q0 1.838 1.567 4.205Q8.76 17.058 12 19.956M12 22a2.3 2.3 0 0 1-.744-.13 2 2 0 0 1-.664-.387 41 41 0 0 1-3.055-3.028Q6.21 16.98 5.32 15.596q-.89-1.383-1.355-2.665-.465-1.28-.465-2.445 0-3.88 2.563-6.183T12 2t5.937 2.303 2.563 6.183q0 1.165-.465 2.445-.464 1.282-1.355 2.665-.89 1.384-2.218 2.86a41 41 0 0 1-3.054 3.027 2 2 0 0 1-.664.388A2.3 2.3 0 0 1 12 22m0-9.65q.877 0 1.5-.609.625-.607.625-1.462 0-.854-.624-1.461A2.07 2.07 0 0 0 12 8.21q-.877 0-1.5.608a1.97 1.97 0 0 0-.625 1.461q0 .855.624 1.462.624.609 1.501.608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.f715b4d39c4b7dc010ae7c484ed85a50.svg";
export { ForwardRef as ReactComponent };